
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"120","height":"120","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M110 55.4V60a49.997 49.997 0 01-67.328 46.873 49.996 49.996 0 01-32.564-50.191A50 50 0 0180.35 14.3","stroke":"#00C97B","stroke-width":"8","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M110 20L60 70.05l-15-15","stroke":"#00C97B","stroke-width":"8","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    